// tslint:disable:no-unsafe-any (autogenerated)
import * as React from 'react';
import Radium from '../../../styling/rostelecom-radium';
import InternationalizedComponent from '../../../../../base/internationalized-component';
import { IRostelecomStyleParamsStoreState } from '../../../styling/rostelecom-styles-store';

interface IIndicatorProps extends React.Props<Indicator> {
    styleParams: IRostelecomStyleParamsStoreState;
    isHidden?: boolean;
}

@Radium
// tslint:disable-next-line:no-default-export (autogenerated)
export default class Indicator extends InternationalizedComponent<IIndicatorProps, {}> {
    private getStyles(): { [style: string]: React.CSSProperties } {
        const { isHidden, styleParams } = this.props;
        return {
            indicator: {
                display: isHidden ? 'none' : 'inline-block',
                float: 'right',
                width: '30px',
                textAlign: 'center',
                fontSize: '12px',
                lineHeight: '27px',
                margin: '0px 2px',
                height: 24,
                border: '1px solid ' + styleParams.neutralColor,
                borderRadius: '3px',
                backgroundColor: '#fff'
            }
        };
    }

    // tslint:disable-next-line:member-access typedef (autogenerated)
    render() {
        const styles = this.getStyles();
        return <span style={styles.indicator}>{this.props.children}</span>;
    }
}
